/****
 * Use this enum to define data to be written to or read from the user storage
 */
export enum UserStorageKey {
  Session = "kahun:session",
  ReloadNeeded = "reloadNeeded",
  Speciality = "custom:specialty",
  UserAgreement = "custom:agreeOnTerms",
  InstallPwa = "custom:installPWA",
  InstallApp = "custom:installAPP",
  PreventStartOver = "preventStartOver",
  NavigationState = "DiagnosticAgent:Navigation",
  PatientCase = `DiagnosticAgent:Current:Patient`,
  AgentType = `DiagnosticAgent:Current:Agent`,
  LastCaseId = "DiagnosticAgent:Current:LastCaseId",
  LastCaseEtag = "DiagnosticAgent:Current:LastCaseEtag",
  WizardCompleteCount = "DiagnosticAgent:Analytics:WizardCompleted",
  LastWizardCompleteTime = "DiagnosticAgent:Analytics:WizardCompletedSessionTime",
  FeatureFlags = "kahun.features-settings",
}
